export interface ToolManagerDto {
    memberId: string;
    memberName: string;
    memberEmail: string;
    role: ToolManagerRole;
    addedOn: string | null;
}

export const ToolManagerRoles = {
    ToolOwner: 'Tool Owner',
} as const;

export type ToolManagerRole = keyof typeof ToolManagerRoles;

export interface AddToolManagerCommand {
    toolId: string;
    memberName: string;
    memberEmail: string;
    memberAdPrinciple: string;
    role: ToolManagerRole;
}

export interface RemoveToolManagerCommand {
    toolId: string;
    memberId: string;
    role: ToolManagerRole;
}